import { useCallback, useState } from 'react';

const SESSION_KEY = 'posterDemoPulseClicked';

const hasClickedThisSession = (): boolean => {
  try {
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  } catch {
    return false; // sessionStorage unavailable (SSR, locked-down browser)
  }
};

export const usePulseSequence = () => {
  const [shouldPulse, setShouldPulse] = useState<boolean>(
    () => !hasClickedThisSession()
  );

  const recordClick = useCallback(() => {
    try {
      sessionStorage.setItem(SESSION_KEY, 'true');
    } catch {
      // swallow — see hasClickedThisSession
    }
    setShouldPulse(false);
  }, []);

  return { shouldPulse, recordClick };
};
